import { LOGGED_OUT_PARAM } from "../../../../shared/loggedOutParam";
import {
  nativeCallbackPath,
  signInSsoPath,
  signOutPath,
} from "../../../lib/apiPaths";

export async function redirectToSSO(
  apiUrl: string,
  currentLocation: Pick<Location, "href" | "search"> = location
): Promise<string | undefined> {
  const isNativeCallback =
    new URLSearchParams(currentLocation.search).get("native") === "true";
  const callbackURL = isNativeCallback
    ? `${apiUrl}${nativeCallbackPath()}`
    : stripLoggedOutParam(currentLocation.href);

  let res: Response;
  try {
    res = await fetch(`${apiUrl}${signInSsoPath()}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ callbackURL }),
    });
  } catch {
    return "Could not reach the authentication server";
  }
  let data: { url?: string; message?: string };
  try {
    data = (await res.json()) as typeof data;
  } catch {
    return `Server returned ${res.status}`;
  }
  if (!res.ok || !data.url) {
    return data.message ?? "SSO sign-in failed";
  }
  currentLocation.href = data.url;
  return undefined;
}

export async function signOut(
  apiUrl: string,
  currentLocation: Pick<Location, "href"> = location
): Promise<void> {
  const signedOut = new URL("/", currentLocation.href);
  signedOut.searchParams.set(LOGGED_OUT_PARAM, "true");

  const res = await fetch(`${apiUrl}${signOutPath()}`, {
    method: "POST",
    credentials: "include",
  }).catch(() => null);
  const body = (await res?.json().catch(() => null)) as { url?: string } | null;
  currentLocation.href = body?.url ?? signedOut.toString();
}

function stripLoggedOutParam(href: string): string {
  const url = new URL(href);
  url.searchParams.delete(LOGGED_OUT_PARAM);
  return url.toString();
}
